module.exports = __webpack_public_path__ + "static/media/translations.1033.dae7c85b.resx";